export const AUCUN = 'Aucune';
export const LETTRE_CHEQUE = 'LettreCheque';
export const VIREMENT = 'Virement';
export const AUTRES = 'Autres';

export const LISTE_ACTION_ACHAT = [
  { code: AUCUN, libelle: 'listeModeReglement.actionAchat.aucun' },
  { code: LETTRE_CHEQUE, libelle: 'listeModeReglement.actionAchat.lettreCheque' },
  { code: VIREMENT, libelle: 'listeModeReglement.actionAchat.virement' },
  { code: AUTRES, libelle: 'listeModeReglement.actionAchat.autres' },
];
